import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setGenome } from "./state/helpers/setGenome";
import {
  getApiUrl,
  getError,
  getLoading,
  getQueryType,
  getVariantId,
} from "./state/selectors/general.selectors";
import { httpRequest } from "./services/http";
import { setError } from "./state/actions/setError";

const CHR_NOTATION = "chr";
// eslint-disable-next-line no-undef
const GENOMES = varsomeConfig.reference_genomes;

const NavbarQueryFormSelect = ({
  refGenomeDisabled,
  selectedGenome,
  searchQuery,
  apiUrl,
  variantId,
  loading,
  error,
  queryType,
}) => {
  const liftedOverRefGenome = selectedGenome === "hg19" ? "hg38" : "hg19";
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const clickHandler = (e) => {
        if (containerRef.current.contains(e.target)) {
          return;
        }
        setIsVisible(false);
      };
      document.addEventListener("click", clickHandler);
      return () => document.removeEventListener("click", clickHandler);
    }

    return () => {};
  }, [isVisible]);

  function select(genome) {
    setIsVisible(false);
    setGenome(genome, searchQuery);
  }

  const setLiftOverError = () => {
    setError(
      `Liftover to ${liftedOverRefGenome} failed. Please try again or contact support. If you wish to see the last results, please refresh this page. `
    );
  };

  const handleLiftOver = () => {
    if (!variantId || !apiUrl) {
      setLiftOverError();
    }
    httpRequest
      .get(`${apiUrl}/get-lifted-over-variant-ids/${variantId}`)
      .then((res) => {
        const liftedOverQuery = res.data[0];
        setGenome(
          GENOMES.filter((x) => x.name !== selectedGenome)[0],
          liftedOverQuery
        );
        setIsVisible(false);
      })
      .catch((err) => {
        console.error(err);
        setLiftOverError();
      });
  };

  return (
    <div ref={containerRef} className="customized-select">
      <div>
        <div
          onClick={() => setIsVisible(!isVisible)}
          className={`select-selected ${
            refGenomeDisabled || loading ? "tw-pointer-events-none" : ""
          }`}
        >
          {selectedGenome}
        </div>
        {isVisible ? (
          <div className="select-items">
            {GENOMES.map((x) => (
              <div
                key={x.name}
                data-tooltip={x.description}
                className="select-item"
                onClick={() => select(x)}
              >
                {x.name}
              </div>
            ))}
            {queryType === CHR_NOTATION && !error && (
              <div
                key="Liftover"
                data-tooltip={`Look up the equivalent position/variant in ${liftedOverRefGenome}`}
                className="select-item"
                onClick={() => {
                  handleLiftOver();
                }}
              >
                {`Liftover  to ${liftedOverRefGenome}`}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedGenome: state?.genome?.name,
    refGenomeDisabled: state.referenceGenomeDisabled,
    apiUrl: getApiUrl(state),
    variantId: getVariantId(state),
    error: getError(state),
    loading: getLoading(state),
    queryType: getQueryType(state),
  };
};

NavbarQueryFormSelect.propTypes = {
  selectedGenome: PropTypes.string,
  searchQuery: PropTypes.string,
  refGenomeDisabled: PropTypes.bool,
  apiUrl: PropTypes.string,
  variantId: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  queryType: PropTypes.string,
};

NavbarQueryFormSelect.defaultProps = {
  selectedGenome: "hg19",
  searchQuery: "",
  refGenomeDisabled: false,
  apiUrl: null,
  variantId: null,
  loading: false,
  error: false,
  queryType: null,
};

export default connect(mapStateToProps, {})(NavbarQueryFormSelect);
